export default __webpack_public_path__ + "static/BPA Staplehurst-2d31781ce963d03b69a1f0125b23c45b.png";